import { EndpointsName } from './../../Auth/authTypes';
import { catchError } from "rxjs/operators";
import { get } from "../../Auth";

const buildGetHintsDataEndpoint = (lang: string, param: string) => `/${lang}/${param}`;

export const getHintsData = (lang: string, param: string) =>
    get(EndpointsName.HINTS, buildGetHintsDataEndpoint(lang, param)).pipe(
        catchError((err) => { throw err })
    )